import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { useLang, useT } from "@/i18n";
import DATA from "@/data/lamellare.json";
import { useCustomFaqs } from "@/lib/customFaqs";

export const HomeFaq = () => {
  const t = useT();
  const { lang } = useLang();
  const custom = useCustomFaqs(lang).map((f) => [f.question, f.answer]);
  const faq = [...custom, ...(DATA[lang] ?? DATA.it).faq.slice(0, 3)];
  return (
    <section id="domande" className="scroll-mt-24 bg-[#F7F5F0] px-5 py-24 text-[#121110] sm:px-8" data-testid="home-faq">
      <div className="mx-auto grid max-w-[1500px] gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#9A5326]">FAQ</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("faq.h", "Domande frequenti sul legno lamellare")}</h2>
          <Link to="/legno-lamellare#faq" className="btn-amber mt-8 w-fit" data-testid="home-faq-link">
            {t("faq.all", "Tutte le domande")} <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="divide-y divide-[#121110]/15 border-y border-[#121110]/15 lg:col-span-8">
          {faq.map(([q, a], i) => (
            <Reveal key={q} delay={i * 0.08} className="py-6" data-testid={`home-faq-${i}`}>
              <h3 className="font-display text-xl font-semibold">{q}</h3>
              <p className="mt-2 text-base leading-relaxed text-[#3D3833]">{a}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
